(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-toastify"), require("react-redux"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react-toastify", "react-redux", "react"], factory);
	else if(typeof exports === 'object')
		exports["ReactToastifyRedux"] = factory(require("react-toastify"), require("react-redux"), require("react"));
	else
		root["ReactToastifyRedux"] = factory(root["react-toastify"], root["react-redux"], root["react"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__) {
return 